export class SelectedBom {
	async root() {
		return [];
	}
}

export class NullSelectedBom extends SelectedBom {
}
